/* eslint no-param-reassign: "error" */
import {
  createSlice,
} from '@reduxjs/toolkit';

import type { DeleteOutputType, EntitySubscribeType } from '@/infra/appsync';
import type {
  DrugJson,
} from '@/types/domain/drug/entities/drugEntity';
import type { DrugStateType } from '@/types/domain/drug/redux';
import type {
  PayloadAction,
} from '@reduxjs/toolkit';

import { service } from '@/share';

const initialState: DrugStateType = {
  drugList: [],
  nextToken: null,
};

/**
 * 薬Slice
 */
export const drugSlice = createSlice({
  name: 'drug',
  initialState,
  reducers: {
    /** 薬リストをセットする */
    setDrugList:
      (state, action: PayloadAction<{
        nextToken: string,
        items: DrugJson[],
      }>) => {
        state.drugList = action.payload.items;
        state.nextToken = action.payload.nextToken;
      },
    /** 薬ストア作成 */
    createDrugStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.drugList = service.drug.createDrugStore(
        state.drugList,
        action.payload,
        undefined,
      );
    },
    /** 薬ストア更新 */
    updateDrugStore: (state, action: PayloadAction<EntitySubscribeType>) => {
      state.drugList = service.drug.updateDrugStore(
        state.drugList,
        action.payload,
      );
    },
    /** 薬ストア削除 */
    deleteDrugStore: (
      state,
      action: PayloadAction<DeleteOutputType>,
    ) => {
      state.drugList = service.drug.deleteDrugStore(
        state.drugList,
        action.payload,
      );
    },
  },
});

export default drugSlice.reducer;
